<ng-container *transloco="let _t">

<div class="chooseHeader">
	<div class="select-btns">
		<h5 class="text-center">{{ _t('main-building-choose-h5-0') }}</h5>
		<p class="text-center">
		<button mat-raised-button color="disabled"
			(click)="selectAll();"
			[title]="_t('main-building-choose-title-0')"
			class="selectallBtn all">
			<mat-icon>done_all</mat-icon>
			<br><small>{{ _t('all') }}</small>
		</button>
		<button mat-raised-button color="disabled"
			(click)="unselectAll();"
			[title]="_t('main-building-choose-title-1')"
			class="selectallBtn none">
			<mat-icon>remove_done</mat-icon>
			<br><small>{{ _t('nothing') }}</small>
		</button>
		</p>
		<!--<p>{{gd.selectedBuildingsList.length}}
			<span *ngIf="gd.selectedBuildingsList.length<=1">{{ _t('main-building-choose-span-0') }}</span>
			<span *ngIf="gd.selectedBuildingsList.length>=2">{{ _t('main-building-choose-span-1') }}</span>
		</p>-->
	</div>
	<div class="viewBtns">
		<button mat-flat-button [title]="_t('main-building-choose-title-2')"
			(click)="viewBy('building')" class="viewByBtn"
			[ngClass]="{'sel':gd.buildingChooserViewMode=='building'}">
			<mat-icon>location_city</mat-icon>
		</button>
		<button mat-flat-button [title]="_t('main-building-choose-title-3')"
			(click)="viewBy('user')"class="viewByBtn"
			[ngClass]="{'sel':gd.buildingChooserViewMode=='user'}">
			<mat-icon>supervisor_account</mat-icon>
		</button>
		<button mat-flat-button [title]="_t('main-building-choose-title-4')"
			(click)="viewBy('town')"class="viewByBtn"
			[ngClass]="{'sel':gd.buildingChooserViewMode=='town'}">
			<mat-icon>location_searching</mat-icon>
			<!--test iconRegistry : <mat-icon svgIcon="country" aria-hidden="false" aria-label="country SVG icon"></mat-icon>-->
		</button>
		<button mat-flat-button [title]="_t('main-building-choose-title-5')"
			(click)="viewBy('buildingType')"class="viewByBtn"
			[ngClass]="{'sel':gd.buildingChooserViewMode=='buildingType'}">
			<mat-icon>account_balance</mat-icon>
		</button>
	</div>
	<div class="filterfield">
		<mat-icon>search</mat-icon>
		<input mat-input type="text" [placeholder]="searchPlaceholder" [(ngModel)]="filter" >
		<button mat-icon-button (click)="filter=''">
			<mat-icon>close</mat-icon>
		</button>
	</div>
  </div>


<ul class="notree" *ngIf="treeType=='notree'">
	<li *ngFor="let building of showedBuilding; let b=index" class="building"
		[ngClass]="{'selected':selectedBuilding==building, 'multiselected': gd.selectedBuildingsList.indexOf(building.id)>-1}">
		<div (click)="selectBuilding($event, building)"
		class="monoselect"
		[title]="_t('main-building-choose-title-6')">
			<small>{{building.name}}</small><br>
			{{building.zipcode}} {{building.town}}
		</div>
		<button mat-icon-button color="disabled" class="multiselect"
		(click)="selectBuilding({'ctrlKey':true}, building)">
			<mat-icon *ngIf="gd.selectedBuildingsList.indexOf(building.id)==-1"
			[title]="_t('main-building-choose-title-7')">
      add_circle</mat-icon>
			<mat-icon *ngIf="gd.selectedBuildingsList.indexOf(building.id)>-1"
			[title]="_t('main-building-choose-title-8')">
      remove_circle_outline</mat-icon>
		</button>
	</li>
</ul>


<ul class="tree" *ngIf="treeType=='tree'">
	<li *ngFor="let rubric of showedRubrics; let r=index"
	class="rubric" [ngClass]="{
		'fold': !rubric.opened,
		'unfold':rubric.opened,
		'selected': selectedRubricList.indexOf(rubric.label)>-1
	}">
  <div class="rubric-title">
    <button class="folding" mat-flat-button (click)="fold(rubric)">
      <mat-icon>arrow_right</mat-icon>
    </button>
		<h4 class="clearfix"
			(click)="selectRubric($event, rubric);"
			[title]="_t('main-building-choose-title-9')">
			{{rubric.label}}
		</h4>
  </div>
		<button mat-icon-button color="disabled" class="multiselect"
		(click)="selectRubric({'ctrlKey':true}, rubric)">
			<mat-icon *ngIf="selectedRubricList.indexOf(rubric.label)==-1"
			[title]="_t('main-building-choose-title-7')">
				add_circle</mat-icon>
			<mat-icon *ngIf="selectedRubricList.indexOf(rubric.label)>-1"
			[title]="_t('main-building-choose-title-8')">
      remove_circle_outline</mat-icon>
		</button>

		<ul *ngIf="rubric.buildings.length>0"
			class="">
			<li *ngFor="let building of rubric.buildings; let b=index"
			class="building"
			[ngClass]="{'selected':selectedBuilding==building, 'multiselected':gd.selectedBuildingsList.indexOf(building.id)>-1}">
				<div (click)="selectBuilding($event, building)"
				class="monoselect"
				[title]="_t('main-building-choose-title-6')">
					<strong>{{building.name}}</strong><br>
					{{building.zipcode}} {{building.town}}
				</div>
				<button mat-icon-button color="disabled" class="multiselect"
				(click)="selectBuilding({'ctrlKey':true}, building)">
					<mat-icon *ngIf="gd.selectedBuildingsList.indexOf(building.id)==-1"
					[title]="_t('main-building-choose-title-7')">
          add_circle</mat-icon>
					<mat-icon *ngIf="gd.selectedBuildingsList.indexOf(building.id)>-1"
					[title]="_t('main-building-choose-title-8')">
          remove_circle_outline</mat-icon>
				</button>
			</li>
		</ul>
	</li>
</ul>

</ng-container>
